import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import TabBar from "rc-tabs/lib/TabBar";
import TabContent from "rc-tabs/lib/TabContent";
import Tabs, { TabPane } from "rc-tabs";
import { SemanasPendientes } from "./components/SemanasPendientes";
import { HistorialMigaDesecho } from "./components/HistorialMigaDesecho";
import "./MigaDesecho.css";

const TAB_PENDIENTES = "PENDIENTES";
const TAB_HISTORIAL = "HISTORIAL";

class MigaDesecho extends Component {
    constructor(props) {
        super(props);

        const params = new URLSearchParams(props.location.search);
        let tabFromUrl = params.get("tab");

        if (!tabFromUrl) {
            tabFromUrl = TAB_PENDIENTES;

            params.set("tab", tabFromUrl);

            this.props.history.replace({
                search: params.toString(),
            });
        }

        this.state = {
            tab: tabFromUrl,
        };
    }

    regresar = () => {
        this.props.history.goBack();
    };

    handleChangeTab = (tab) => {
        this.setState({ tab });

        const params = new URLSearchParams(this.props.location.search);
        params.set("tab", tab);

        this.props.history.replace({
            search: params.toString(),
        });
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="inventario_activo"
                    titulo="MIGA DE DESECHO"
                    subtitulo=""
                    noBorder
                >
                    <Tabs
                        activeKey={this.state.tab}
                        tabBarPosition="top"
                        onChange={this.handleChangeTab}
                        renderTabBar={() => <TabBar />}
                        renderTabContent={() => <TabContent animated={false} />}
                    >
                        <TabPane
                            tab="Semanas pendientes"
                            key={TAB_PENDIENTES}
                        >
                            <SemanasPendientes
                                tabActiva={this.state.tab === TAB_PENDIENTES}
                                regresar={this.regresar}
                            />
                        </TabPane>

                        <TabPane tab="Historial" key={TAB_HISTORIAL}>
                            <HistorialMigaDesecho
                                tabActiva={this.state.tab === TAB_HISTORIAL}
                                regresar={this.regresar}
                            />
                        </TabPane>
                    </Tabs>
                </Card>
            </div>
        );
    }
}

export default connect(null, {})(MigaDesecho);
